import { Reflector } from '../reflection';
export function inject(token) {
  return function (target, _, index) {
    Reflector.addManuallyInjectedDeps(target, [{
      index: index,
      token: token
    }]);
  };
}